import { FC } from 'react'
import classNames from 'classnames'
import { FlexRow } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { CaptionLG } from '@/atoms/Text'
import { InfiniteScrollCarousel } from '@/molecules/InfiniteScrollCarousel/InfiniteScrollCarousel'
import { GiveawayPartnerLogo, Maybe } from '@/types/codegen-contentful'
import { useGiveawayContext } from '../../context/GiveawayContext'

interface Props {
  partnerLogos: Maybe<GiveawayPartnerLogo>[]
  text?: Maybe<string>
}

export const PartnerLogosSection: FC<Props> = ({ partnerLogos, text }) => {
  const { isActive } = useGiveawayContext()

  if (!partnerLogos.length) return <div className={classNames(isActive ? 'h-[60px]' : '')}></div>

  return (
    <div className="grid gap-4 py-20">
      {text && (
        <CaptionLG className="block text-center uppercase" color="core-gray-700">
          {text}
        </CaptionLG>
      )}
      {partnerLogos.length === 1 ? (
        <FlexRow className="justify-center">
          <div
            className="relative h-[140px] w-[300px]"
            style={{
              ...(partnerLogos[0]?.maxWidth && {
                maxWidth: `${partnerLogos[0].maxWidth}px`,
                maxHeight: `${partnerLogos[0].maxWidth * (140 / 300)}px`,
              }),
            }}
          >
            <Image
              src={partnerLogos[0]?.imageUrl || ''}
              alt={partnerLogos[0]?.altText || ''}
              fill
              className="object-contain"
            />
          </div>
        </FlexRow>
      ) : (
        <InfiniteScrollCarousel
          images={partnerLogos.map((partnerLogo) => ({
            alt: partnerLogo?.altText ?? '',
            src: partnerLogo?.imageUrl ?? '',
            maxWidth: partnerLogo?.maxWidth,
          }))}
        />
      )}
    </div>
  )
}
